import { DocumentTitle } from '../../components/shared/DocumentTitle';
import { ReportListHome } from '../report/ReportListHome';
import { useAuthContext } from '../../contexts/AuthContext';
import { useZoneContext } from '../../contexts/useZoneContext';

function ReportListWrapper() {
    const { user } = useAuthContext();
    const zoneContext = useZoneContext();

    return (
        <>
            <DocumentTitle title="Report Tool" />
            <ReportListHome user={user} zoneContext={zoneContext} />
        </>
    );
}

export default ReportListWrapper;
